import { render } from "./Svg.vue?vue&type=template&id=54a1a967&scoped=true"
import script from "./Svg.vue?vue&type=script&lang=ts"
export * from "./Svg.vue?vue&type=script&lang=ts"

import "./Svg.vue?vue&type=style&index=0&id=54a1a967&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54a1a967"

export default script